import TorusKnotModel from "./models/TorusKnotModel";

import SphereModel from "./models/SphereModel";

import SuzanneModel from "./models/SuzanneModel";

import MilkTruckModel from "./models/MilkTruckModel";

import DragonModel from "./models/DragonModel";

import AvocadoModel from "./models/AvocadoModel";

import BarramundiFishModel from "./models/BarramundiFishModel";

export const MODEL_LIBRARY = {
  "torus-knot": TorusKnotModel,
  sphere: SphereModel,
  suzanne: SuzanneModel,
  "milk-truck": MilkTruckModel,
  dragon: DragonModel,
  avocado: AvocadoModel,
  "barramundi-fish": BarramundiFishModel,
};

export const MODEL_LIST = [
  TorusKnotModel,
  SphereModel,
  SuzanneModel,
  MilkTruckModel,
  DragonModel,
  BarramundiFishModel,
];

export function getModel(id) {
  return MODEL_LIBRARY[id] ?? TorusKnotModel;
}
